import React from 'react';
import {
    List,
    Typography,
    withStyles,
    Paper,
    Chip,
    Box,
    Grid,
    Divider,
    ButtonBase
} from '@material-ui/core';
import styles from './styles';
import {withTranslation} from 'react-i18next';
import {compose} from 'recompose';
import PropTypes from 'prop-types';
import BikeIcon from '@material-ui/icons/DirectionsBike';
import InboxIcon from '@material-ui/icons/Inbox';
import {getTourStatusSting} from "../../../services/enums/TourStatus";
import InfoIcon from '@material-ui/icons/Info';

const getTourLabel = (tour) => {
    if (tour.tourNumber) {
        return `${tour.tourNumber}${tour.tourCutNumber ? `-${tour.tourCutNumber}` : ''}`;
    }
    return tour.tourName || `ID: ${tour.tourId}`;
};

function DriverTours(props) {

    const {tours, onSelectTour, classes, t} = props;

    if (tours.length === 0) {
        return (
            <Box className={classes.noToursBox}>
                <Typography variant="h6" color="textSecondary">
                    {t('noInDeliveryToursAvailableDashboard')}
                </Typography>
            </Box>
        );
    }

    return (
        <Box className={classes.root}>
            <Paper
                elevation={0}
                className={classes.paper}
            >
                <InfoIcon style={{ marginRight: '12px', color: '#1976d2' }} />
                <Typography variant="body2" style={{ fontWeight: 500 }}>
                    {t('infoForDriverFullGoods')}
                </Typography>
            </Paper>
            
            <List disablePadding>
                {
                    tours.map((tour) => {
                        const statusConfig = {label: t(getTourStatusSting(tour.tourStatus))}
                        const tourLabel = getTourLabel(tour);

                        return (
                            <Paper
                                key={tour.tourId}
                                elevation={2}
                                className={classes.tourCard}
                                style={{
                                    borderLeft: `6px solid ${tour.color}`
                                }}
                            >
                                <ButtonBase
                                    onClick={() => onSelectTour(tour)}
                                    className={classes.cardActionArea}
                                >
                                    <Box className={classes.cardContent}>
                                        <Box className={classes.cardHeader}>
                                            <Box className={classes.vehicleWrapper}>
                                                <BikeIcon className={classes.vehicleIcon}/>
                                                <Typography variant="h6" className={classes.vehicleText}>
                                                    {tour.vehicleLicensePlate || t('noVehicle')}
                                                </Typography>
                                            </Box>

                                            <Chip
                                                label={statusConfig.label}
                                                icon={statusConfig.icon}
                                                size="small"
                                                className={classes.statusChip}
                                            />
                                        </Box>

                                        <Box className={classes.tourInfoBox}>
                                            <Typography variant="body1" color="textPrimary"
                                                        className={classes.tourLabel}>
                                                Tour {tourLabel}
                                            </Typography>
                                            <Typography variant="body2" color="textSecondary">
                                                {tour.shipperName} • {tour.microHubName}
                                            </Typography>
                                        </Box>

                                        <Divider light/>

                                        <Box className={classes.footerBox}>
                                            <Grid container spacing={1} alignItems="center">
                                                <Grid item xs={12}>
                                                    <Box className={classes.metaDataBox}>
                                                        <InboxIcon className={classes.smallIcon}/>
                                                        <Typography variant="caption" className={classes.captionText}>
                                                            <strong>{tour.stops ? tour.stops.length : 0}</strong> {t('stops')}
                                                            {tour.tourCapacities?.boxAmount > 0 &&
                                                                ` • ${tour.tourCapacities.boxAmount} ${t('boxes')}`
                                                            }
                                                        </Typography>
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                        </Box>
                                    </Box>
                                </ButtonBase>
                            </Paper>
                        );
                    })
                }
            </List>
        </Box>
    );
}

DriverTours.propTypes = {
    tours: PropTypes.array.isRequired,
    onSelectTour: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
};

export default compose(withStyles(styles), withTranslation())(DriverTours);